import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { Perk } from '../perks.types';

export const usePatchPerk = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS);
  const { mutate: patchPerk, isPending } = useAppMutation([QueryKey.PERKS, QueryKey.PATCH], {
    mutationFn: ({
      data,
      id,
    }: {
      data: Partial<Except<Perk, 'clicksCount' | 'createdAt' | 'draft' | 'id' | 'updatedAt'>>;
      id: string;
    }) => {
      return ApiService.patch(
        {
          endpoint: BackendRoute.PERKS,
          routePath: [id],
        },
        { regularBackend: true, body: data },
      );
    },
    onSuccess: (_, { id }) => {
      invalidateQuery(id);
      toast.success('Changes are successfully saved');
    },
    defaultErrorHandling: false,
    onError: () => {
      toast.error('Couldn’t save changes. Please try again.');
    },
  });

  return {
    isPending,
    patchPerk,
  };
};
